export enum CompanyTypes {
    INSTALLER       = 'installer',
    DISTRIBUTOR     = 'distributor',
};

export enum REG_STATUS {
    PENDING         = 'pending',
};

export enum SYSTEM_TYPES {
   GAS_BOILER = 'gas_boiler',
   HEAT_PUMPS = 'heat_pump',
   SOLAR = 'solar',
   OTHER = 'other',
};

export const FILE_DOWNLOAD_DELAY = 500;

export const MAX_FILE_SIZE_10MB = 10485760;
export const MAX_FILE_SIZE_100MB = 104857600;

export enum SEARCH_FILTERS {
    COMPANY = 'companySearchFilter',
    COURSE  = 'courseSearchFilter',
    EVENT   = 'eventSearchFilter',
    QUIZ    = 'quizSearchFilter',
    USER    = 'userSearchFilter',
    VENUE   = 'venueSearchFilter',
    CLAIM   = 'claimSearchFilter',
    // The whole query string rather than just the search term, so the filters come back too.
    APPLIANCE = 'applianceListParams',
}

export enum PRODUCT_TABLES {
    PARENTS  = 'product_parents',
    CHILDREN = 'product_children',
    TYPES    = 'product_types',
    LINES    = 'product_lines',
}

export enum DISTRIBUTOR_CLAIM_TYPES {
   POST_REPAIR = 'claim_post_repair',
   PRE_REPAIR = 'claim_pre_repair',
}